import React from "react";
import { VstTable, VstLoader } from "vstui";

var Isvg = require("../../../vendor/react-inlinesvg");

class ResourcesTable extends React.Component {
  constructor() {
    super();
    this.state = {
      ancillaries: null
    };

    this._hasDownloadable = this._hasDownloadable.bind(this);
    this._downloadAll = this._downloadAll.bind(this);
    this._countAncillaries = this._countAncillaries.bind(this);
    this._getName = this._getName.bind(this);
    this._getAction = this._getAction.bind(this);
    this._buildRow = this._buildRow.bind(this);
    this._preprocess = this._preprocess.bind(this);
    this._onClick = this._onClick.bind(this);
    this._getHeaders = this._getHeaders.bind(this);
    this._tableRows = this._tableRows.bind(this);
  }

  componentDidMount() {
    this._loadAncillaries();
  }

  _loadAncillaries() {
    Jigsaw.getAncillariesForVbid(this.props.isbn, response => {
      if (response.isSuccess()) {
        this.setState({
          ancillaries: response.data.ancillaries
        });
      }
    });
  }

  _hasDownloadable() {
    if (this.state.ancillaries) {
      return this.state.ancillaries.some(
        ({ type, href }) => type === "file" && href
      );
    }
  }

  _downloadAll() {
    let delay = 0;
    this.state.ancillaries
      .filter(({ type, href }) => type === "file" && href)
      .forEach(({ href, title }) => {
        const link = document.createElement("a");
        link.download = "";
        link.href = href;
        link.style.display = "none";
        document.body.appendChild(link);
        link.dispatchEvent(new MouseEvent("click"));
        document.body.removeChild(link);
      });
  }

  _countAncillaries() {
    const {
      badgeData: {
        ancillaries: { ancillariesCount, accessCodeCount }
      }
    } = this.props;
    return ancillariesCount + accessCodeCount;
  }

  _getName(ancillary) {
    const title = ancillary.title.decodeHTML();
    const url = ancillary.href && (
      <a href={ancillary.href}>{ancillary.href.replace(/(^\w+:|^)\/\//, "")}</a>
    );
    return title || url || "";
  }

  _getAction(ancillary) {
    if (ancillary.type === "file") {
      return this.renderActionFile();
    }
    return this.renderActionButton();
  }

  _buildRow(ancillary) {
    return [
      <VstTable.Cell>{this._getName(ancillary)}</VstTable.Cell>,
      <VstTable.Cell>{ancillary.type || ""}</VstTable.Cell>,
      <VstTable.Cell>{ancillary.size || ""}</VstTable.Cell>,
      <VstTable.Cell>{this._getAction(ancillary)}</VstTable.Cell>
    ];
  }

  _preprocess(ancillary) {
    if (ancillary.type === "file") {
      ancillary.fileType = ancillary.href.substr(
        ancillary.href.lastIndexOf(".") + 1
      );
    } else if (ancillary.type === "url") {
      ancillary.size = null;
    }
    ancillary.title = ancillary.title || this.props.badgeData.ancillaries.title;
    return ancillary;
  }

  _onClick(ancillary) {
    if (ancillary.type === "accesscode") {
      if (ancillary.href) {
        Fraction.Helpers.safeRedirect(ancillary.href, true);
      } else {
        Fraction.Helpers.ssoToOldOnlineURL(
          Fraction.Brand.Locations.Resources,
          true
        );
      }
    } else if (ancillary.type === "file") {
      window.location.href = ancillary.href;
    } else {
      Fraction.Helpers.safeRedirect(ancillary.href, true);
    }
  }

  _getHeaders() {
    return [
      i18n.t("library.slideout.name"),
      i18n.t("library.slideout.type"),
      i18n.t("library.slideout.size"),
      ""
    ];
  }

  _tableRows() {
    if (this.state.ancillaries) {
      return this.state.ancillaries
        .map(this._preprocess)
        .map((ancillary, index) => {
          const onClick = () => this._onClick(ancillary);
          return (
            <VstTable.Row key={`ancillary-${index}`} onClick={onClick}>
              {this._buildRow(ancillary)}
            </VstTable.Row>
          );
        });
    }
    return [[<VstLoader />, "", "", ""]];
  }

  renderActionButton() {
    if (Fraction.Helpers.isSmallScreen()) {
      return (
        <span>
          <span className="offScreen">{i18n.t("library.slideout.launch")}</span>
          <Isvg src={"/img/launch_icon.svg"} />
        </span>
      );
    }
    return <div className="blue-btn">{i18n.t("library.slideout.launch")}</div>;
  }

  renderActionFile() {
    if (Fraction.Helpers.isSmallScreen()) {
      return (
        <span>
          <span className="offScreen">
            {i18n.t("library.slideout.download")}
          </span>
          <Isvg src={"/img/download_icon.svg"} />
        </span>
      );
    }
    return (
      <div className="blue-btn">{i18n.t("library.slideout.download")}</div>
    );
  }

  renderDownloadAll() {
    if (this._hasDownloadable() && Fraction.Helpers.isChrome()) {
      return (
        <button
          className="download noButton"
          onClick={() => this._downloadAll()}
        >
          {i18n.t("library.download-all")}
        </button>
      );
    }
  }

  render() {
    if (this.props.badgeData && this.props.badgeData.ancillaries) {
      const amount = this._countAncillaries();
      return (
        <div id="resources-table">
          <h3 className="slideout-number">
            {amount === 1
              ? i18n.t("library.slideout.ancillary-amount")
              : i18n.t("library.slideout.ancillaries-amount", { amount })}
          </h3>

          {this.renderDownloadAll()}

          <div className="slideout-table">
            <VstTable height="100%">
              <VstTable.Header>
                {[
                  i18n.t("library.slideout.name"),
                  i18n.t("library.slideout.type"),
                  i18n.t("library.slideout.size"),
                  ""
                ]}
              </VstTable.Header>
              <VstTable.Body>{this._tableRows()}</VstTable.Body>
            </VstTable>
          </div>
          <button
            className="collapse-arrow noButton"
            onClick={this.props._toggleSlideout}
          >
            <Isvg src={"/img/arrow_legacy.svg"} /> {i18n.t("base.collapse")}
          </button>
        </div>
      );
    }
    return <span />;
  }
}

export default ResourcesTable;
